<script>
    import {onMount} from "svelte"
    import {XYZtoRGB} from "./color.js"

    export let spectrum = {}
    export let monoXYZ
    export let multiply

    let nmStep = 10
    let minNm = 380
    let maxNm = 780

    export let sum = 0

    let prevNm, prevIntensity

    for (let i = minNm; i <= maxNm; i += nmStep) {
        spectrum[i] = 0 //Math.sin((2 * i) / 100) * 0.5 + 0.5
    }

    let path = "M0,0"
    $: {
        path = "M0,0"
        for (let i = minNm; i <= maxNm; i += nmStep) {
            let x = 200 * ((i - minNm) / (maxNm - minNm))
            let y = 100 * (1 - spectrum[i])
            path += `L${x},${y}`
        }
    }

    let multiplyPath = "M0,0"
    $: if (multiply) {
        sum = 0
        for (let i = minNm; i <= maxNm; i += nmStep) {
            sum += spectrum[i] * multiply[i]
        }

        multiplyPath = "M0,100"
        for (let i = minNm; i <= maxNm; i += nmStep) {
            let x = 200 * ((i - minNm) / (maxNm - minNm))
            let y = 100 * (1 - spectrum[i] * multiply[i])
            multiplyPath += `L${x},${y}`
        }
    }

    function handleMousemove(event) {
        if (mousedown) {
            if (event.touches) {
                event.clientX = event.touches[0].pageX
                event.clientY = event.touches[0].pageY
            }
            let loc = cursorPoint(event)
            let nm = (loc.x / 200) * (maxNm - minNm) + minNm
            nm = Math.round(nm / nmStep) * nmStep
            let intensity = Math.max(0, 1 - loc.y / 100)
            spectrum[nm] = intensity
            if (prevNm) {
                let step = nmStep
                if (prevNm > nm) {
                    step = -step
                }
                for (let i = prevNm; i != nm; i += step) {
                    spectrum[i] =
                        prevIntensity +
                        (intensity - prevIntensity) *
                            ((i - prevNm) / (nm - prevNm))
                }
            }
            prevNm = nm
            prevIntensity = intensity
        } else if (mousedown2) {
            if (event.touches) {
                event.clientX = event.touches[0].pageX
                event.clientY = event.touches[0].pageY
            }
            let loc = cursorPoint(event)
            let nm = (loc.x / 200) * (maxNm - minNm) + minNm
            nm = Math.round(nm / nmStep) * nmStep
            let intensity = Math.max(0, 1 - loc.y / 100)
            for (let i = minNm; i <= maxNm; i += nmStep) {
                spectrum[i] = 0
            }
            spectrum[nm] = intensity
        }
    }

    let mousedown = false,
        mousedown2 = false
    function handleMousedown(event) {
        if (event.button === 0) {
            mousedown = true
        } else if (event.button === 1) {
            mousedown2 = true
        }
        handleMousemove(event)
    }
    function handleMouseup(event) {
        if (event.button === 0) {
            mousedown = false
        } else if (event.button === 1) {
            mousedown2 = false
        }
        prevNm = undefined
        prevIntensity = undefined
        handleMousemove(event)
    }

    var pt
    var svg
    onMount(async () => {
        // Create an SVGPoint for future math
        pt = svg.createSVGPoint()
    })

    function cursorPoint(evt) {
        pt.x = evt.clientX
        pt.y = evt.clientY
        return pt.matrixTransform(svg.getScreenCTM().inverse())
    }

    let rects = []
    $: {
        if (monoXYZ) {
            rects = []
            for (let i = minNm; i <= maxNm; i += nmStep) {
                let xyzValues = monoXYZ(i)
                let rgbValues = XYZtoRGB(xyzValues.X, xyzValues.Y, xyzValues.Z)
                let rgb = `rgb(${rgbValues.r * 255}, ${rgbValues.g * 255}, ${
                    rgbValues.b * 255
                })`

                rects.push({
                    x: ((i - minNm) / (maxNm - minNm)) * 200,
                    y: 0,
                    width: (nmStep / (maxNm - minNm)) * 210,
                    height: 100,
                    fill: rgb,
                })
            }
        }
    }
</script>

<main>
    <svg
        bind:this={svg}
        on:mousedown={handleMousedown}
        on:mouseup={handleMouseup}
        on:mousemove={handleMousemove}
        on:touchstart={handleMousedown}
        on:touchend={handleMouseup}
        on:touchmove={handleMousemove}
        viewBox="-10 -10 220 120"
    >
        {#each rects as r}
            <rect
                x={r.x}
                y={r.y}
                width={r.width}
                height={r.height}
                fill={r.fill}
                stroke="none"
            />
        {/each}

        <line x1="0" y1="100" x2="200" y2="100" stroke="white" />
        <line x1="0" y1="100" x2="0" y2="0" stroke="white" />

        <text x="-8" y="108" font-size="5" fill="white"> {minNm} nm </text>
        <text x="190" y="108" font-size="5" fill="white"> {maxNm} nm </text>

        <path d={path} stroke={monoXYZ ? "white" : "white"} fill="none" />
        {#if multiply}
            <path d={multiplyPath} stroke="none" fill="#999" />
        {/if}
    </svg>
</main>

<style>
    svg {
        width: 20em;
    }
</style>
